import * as T from 'prop-types';

import { Flex } from '@olist/united';

import { CustomCard, CustomText } from './informative-card.styles';

export const InformativeCard = ({ icon, message, messageColor, variation }) => (
  <CustomCard variation={variation} messageColor={messageColor}>
    <CustomCard.Body>
      <Flex>
        {icon}
        <CustomText>{message}</CustomText>
      </Flex>
    </CustomCard.Body>
  </CustomCard>
);

InformativeCard.propTypes = {
  message: T.string.isRequired,
  variation: T.string.isRequired,
  messageColor: T.string.isRequired,
  icon: T.node.isRequired,
};
